import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

import { cloudPcManagementRoutes } from './cloud-pc-management/cloud-pc-management-routes';
import { cloudPrintManagementRoutes } from './cloud-print-management/cloud-print-management-routes';
import { databaseEngineManagementRoutes } from './database-engine-management/database-engine-management-routes';
import { networkManagementRoutes } from './network-management/network-management-routes';
import { partnerPortalAccessInfoRoutes } from './partner-portal-access-info/partner-portal-access-info-routes';
import { secureEmailDomainRoutes } from './secure-email-domain/secure-email-domain-routes';
import { secureIdentityRoutes } from './secure-identity/secure-identity-routes';
import { securityIntrusionDetectionAndResponseRoutes } from './security-intrusion-detection-and-response/security-intrusion-detection-and-response-routes';
import { serverManagementRoutes } from './server-management/server-management-routes';

export const advaniaServicesChildRoutes: Routes = [
    ...cloudPcManagementRoutes,
    ...cloudPrintManagementRoutes,
    ...secureEmailDomainRoutes,
    ...secureIdentityRoutes,
    ...securityIntrusionDetectionAndResponseRoutes,
    ...serverManagementRoutes,
    ...networkManagementRoutes,
    ...databaseEngineManagementRoutes,
    ...partnerPortalAccessInfoRoutes,
    {
        path: `:serviceId/${advaniaServicesSegments.notifications}`,
        loadComponent: () =>
            import('./generic-services/pages/advania-service-notifications-page/advania-service-notifications.page').then(
                (m) => m.AdvaniaServiceNotificationsPage,
            ),
    },
];
